export default __webpack_public_path__ + "static/media/shape-cross.ae66ad59.PNG";